import * as React from 'react';
import { useIntl } from 'react-intl';
import * as EmployeeService from './EmployeeService';
import ConfirmDialog from '../ConfirmDialog';
import { IEmployeeConfrimDialog } from './interfaces';
import LoaderService from '../../Services/LoaderService';

function ResetUser(props: IEmployeeConfrimDialog): JSX.Element {
  const { formatMessage: f } = useIntl();

  const closeConfirmDialog = () => {
    props.handleConfirmDialogOpen(false);
  };

  const handleSubmitResetConfirmDialog = async (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.preventDefault();
    LoaderService.showLoader();
    const res = await EmployeeService.reset(props.selectedIds[0]);
    if (res) {
      props.updateTable();
      props.handleConfirmDialogOpen(false);
    }
    LoaderService.showLoader(false);
  };

  const handleSubmitMultipleResetConfirmDialog = async (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.preventDefault();
    LoaderService.showLoader();
    const res = await EmployeeService.resetMultiple(props.selectedIds);
    if (res) {
      props.updateTable();
      props.handleConfirmDialogOpen(false);
    }
    LoaderService.showLoader(false);
  };

  return props.selectedIds.length > 1 ? (
    <ConfirmDialog
      title={`${f({ id: 'forgotPassword.passwordReset' })}`}
      cancelCallback={closeConfirmDialog}
      continueCallback={handleSubmitMultipleResetConfirmDialog}
      cancelButtonTitle={f({
        id: 'form.cancel',
      })}
      continueButtonTitle={f({
        id: 'forgotPassword.send',
      })}
    >
      {f(
        { id: 'table.confirm.dialog.multiple.reset.message' },
        { count: props.selectedIds.length }
      )}
    </ConfirmDialog>
  ) : (
    <ConfirmDialog
      title={`${f({ id: 'forgotPassword.passwordReset' })}`}
      cancelCallback={closeConfirmDialog}
      continueCallback={handleSubmitResetConfirmDialog}
      cancelButtonTitle={f({
        id: 'form.cancel',
      })}
      continueButtonTitle={f({
        id: 'forgotPassword.send',
      })}
    >
      {f({ id: 'table.confirm.dialog.reset.message' }, { name: `${props.fullname}` })}
    </ConfirmDialog>
  );
}

export default ResetUser;
